import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { SearchView } from './search.view';
import { SearchView as SearchNewView } from './searchNew.view';

export const SearchRoutes = (): JSX.Element => {
  const flags = useFeatureFlag(['new-search-conversations-view']);

  return (
    <Routes>
      <Route index element={<Navigate to="conversations" replace />} />

      <Route
        path=":scope"
        element={
          flags.newSearchConversationsView ? <SearchNewView /> : <SearchView />
        }
      />

      {/* Redirect legacy search contacts routes to the contacts routes. */}
      <Route path="users" element={<Navigate to="/contacts/user" replace />} />
      <Route
        path="companies"
        element={<Navigate to="/contacts/company" replace />}
      />
    </Routes>
  );
};
